import React from "react";
import { useHistory, useLocation } from "react-router";
import split from "ramda/src/split";
import pathOr from "ramda/src/pathOr";
import compose from "ramda/src/compose";

import { URL } from "../../constants/navigation";
import { Typography } from "../../UI/Typography";
import { Grid } from "../../UI/Grid";
import { handleNavigation } from "../../helpers/handleNavigation";

const CHILD_LABELS_BY_URL = {
  [URL.USERS_INVITE]: "Invite",
  [URL.USERS_REMOVE]: "Remove",
  [URL.USERS_SEARCH]: "Search",
  [URL.USERS_MATCH]: "Match",
  [URL.USER_REPORT]: "User Report",
  [URL.ROOMMATE_MATCHING_REPORT]: "Roommate Report",
};

const PARENT_LABELS_BY_URL = {
  [URL.USERS_INVITE]: "Users",
  [URL.USERS_REMOVE]: "Users",
  [URL.USERS_SEARCH]: "Users",
  [URL.USERS_MATCH]: "Users",
  [URL.USER_REPORT]: "Reports",
  [URL.ROOMMATE_MATCHING_REPORT]: "Reports",
};

const getPath = compose(pathOr(URL.USERS_SEARCH, [0]), split("?"));

export const Breadcrumbs = () => {
  const { push } = useHistory();
  const location = useLocation<{ breadcrumbs: string[] }>();

  const breadcrumbs = location?.state?.breadcrumbs || [];

  if (!breadcrumbs.length) {
    return null;
  }

  const handleClick = (url: string) => (event: React.MouseEvent) => handleNavigation(event, url, push);

  return (
    <Grid container spacing={1} component="ul" display="flex" p={0} sx={{ listStyleType: "none" }} alignItems="center">
      <Grid item component="li">
        <Typography variant="subtitle1">{PARENT_LABELS_BY_URL[getPath(breadcrumbs[0])]}</Typography>
      </Grid>
      <Grid item component="li">
        /
      </Grid>
      {breadcrumbs.map((path) => (
        <Grid item component="li" key={path}>
          <Typography variant="subtitle1" onClick={handleClick(path)} sx={{ cursor: "pointer" }}>
            {CHILD_LABELS_BY_URL[getPath(path)]}
          </Typography>
        </Grid>
      ))}
    </Grid>
  );
};
